import axios from 'axios'

const get = async (id) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/show-upload/id/${id}`)
  return data
}

// Start upload
const start = async (
  session,
  show,
  filename,
  lastModified,
  size
) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/show-upload`, {
    session,
    show,
    filename,
    lastModified,
    size
  })
  return data
}

const cancel = async (id) => {
  const { data } = await axios.delete(`${process.env.VUE_APP_API}/show-upload/${id}`)
  return data
}

const uploading = async (id) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/show-upload/${id}`)
  return data
}

export {
  get,
  start,
  cancel,
  uploading
}
